import type { UiText } from "./kratos";

// Kratos message ids reworded in Kora's voice; anything not listed keeps Kratos's text.
const MESSAGES: Record<number, string> = {
  4000006: "Email or password doesn’t match.",
  4000007: "An account with this email already exists. Sign in instead.",
  4000010: "Verify your email before signing in. We can send you a new link.",
  4010001: "This sign-in took too long. Start again.",
  4040001: "This sign-up took too long. Start again.",
  4060004: "This reset link has expired or was already used. Request a new one.",
  4060005: "This reset took too long. Request a new link.",
  4070001: "This verification link has expired or was already used. Request a new one.",
  4070005: "This verification took too long. Request a new link.",
  4010008: "That code doesn’t match. Check the latest email and try again.",
  1010014: "We sent a sign-in code to your email.",
  1060001: "Choose a new password to finish resetting your account.",
  1060002: "If an account exists for that email, we sent a link to reset the password.",
  1080001: "We sent a verification link to your email.",
  1080002: "Your email is verified.",
  1050001: "Your changes are saved.",
};

export const copy = (message: UiText) => MESSAGES[message.id] ?? message.text;

export const UNVERIFIED_ADDRESS = 4000010;
export const RECOVERED = 1060001;

// The pre-registration webhook turns the part of the email before the @ into a username capped at 32 characters,
// and rejects longer ones instead of shortening them.
const USERNAME_FROM_EMAIL = "We couldn’t create an account for this email address. Try an address with fewer characters before the @.";

/** Words for an error on a field the page doesn't show. */
export const copyFor = (field: string, message: UiText) => (field === "traits.username" ? USERNAME_FROM_EMAIL : copy(message));
